// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__29Pi8","unreadBadge":"styles_unreadBadge__3ovEO","modalContent":"styles_modalContent__O9_TG","modal":"styles_modal__1bpbl"};